<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px;">
        <div class="n2-padding n2-text-center">
            <h5>{{$t('pages.success.title')}}</h5>
            <div v-html="$t('pages.success.description')"></div>
        </div>
        <div class="n2-margin-top" style="position:relative; padding-bottom:20px; display:flex; justify-content:center;">

            <div style="display: table; cursor:pointer;" v-on:click="download">
                <div style="display: table-cell; vertical-align: middle;">
                    <i aria-hidden="true" class="fa fa-cloud-download" style="font-size: 2em;"></i>
                </div>
                <div style="display: table-cell; vertical-align: middle; padding: 5px; text-decoration:underline;">{{$t('pages.success.download')}}</div>
            </div>
            <app-loader v-bind:active="loading_pdf"></app-loader>
        </div>
        <div style="background:#fff; padding:20px;">
            <div v-html="order_html"></div>
        </div>
    </div>


</template>

<script>

    import { OrderService } from '../services'
    import AppLoader from '../components/shared/loader.vue'

    export default {
        components: {
            AppLoader
        },
        data: function () {
            return {
                order: {},
                order_html: '',
                loading_pdf: false
            }
        },
        created: function () {
            this.orderService = new OrderService()
        },
        mounted: async function () {
            this.order = await this.orderService.find(this.$route.query.order_id);
            this.order_html = await this.orderService.getHtml(this.order.id, this.order.template)

        },
        methods: {
            download: async function () {
                this.loading_pdf = true
                try {
                    let pdf = await this.orderService.getPdf(this.order.id, this.order.template)
                    console.log(pdf)
                    const file = new Blob(
                        [pdf],
                        { type: 'application/pdf' });
                    var url = window.URL.createObjectURL(file)
                    var a = document.createElement('a')
                    a.href = url
                    a.download = this.order.booking_number
                    a.click()
                    a.remove()
                    setTimeout(() => window.URL.revokeObjectURL(url), 100)
                }
                finally {
                    this.loading_pdf = false
                }
            }
        }
    }
</script>
